import { Minus } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconMinus(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Minus />
    </IconWrapper>
  );
}
